import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import * as styles from "./headerStyles";
import { HeaderSettings } from "../../types/Settings";

const DEFAULT_LOGO = {
    url: "images/illustrations/NXP-HSV-Wempe_trimmed.svg",
    alt: "HSV-NXP Partnerschaftslogo",
};

interface HeaderProps {
    header?: HeaderSettings;
}

// Shows the default logo until the CMS settings are loaded or when no logo is set there
const Header: React.FC<HeaderProps> = ({ header }) => {
    const logo = header?.logoUrl
        ? { url: header.logoUrl, alt: header.alt || DEFAULT_LOGO.alt }
        : DEFAULT_LOGO;

    return (
        <Box sx={styles.headerStyles}>
            <Box component={RouterLink} to="/" sx={styles.logoLinkStyles}>
                <Box
                    component="img"
                    sx={styles.logoStyles}
                    alt={logo.alt}
                    src={logo.url}
                />
            </Box>
        </Box>
    );
};

export default Header;
